'use client';

import React, { useEffect, useState, ReactNode } from 'react';
import { debounce } from 'lodash';
//import {useHashState} from "@/app/hooks/useHash";
import { scrollToSection } from '@/utils';

export type sidebarItem = {
  id: number;
  type: string;
  content: string;
  href: string;
  isActive: boolean;
  hash?: string;
};

type sidebarProps = {
  title?: ReactNode;
  sidebarItems: sidebarItem[];
};

function classNames(...classes: string[]) {
  return classes.filter(Boolean).join(' ');
}

const Sidebar = ({ title, sidebarItems }: sidebarProps) => {
  //const [hash,] = useHashState();
  const [sidebarItemsState, setSidebarItemsState] =
    useState<sidebarItem[]>(sidebarItems);
  const updateSidebarItems = (
    items: sidebarItem[],
    hash: string | undefined
  ) => {
    return items.map((item, index) => {
      return {
        ...item,
        isActive: hash ? item.hash === hash : index === 0,
      };
    });
  };

  useEffect(() => {
    const handleScroll = debounce(() => {
      const sectionElements = sidebarItems.map((section) =>
        document.getElementById(section.hash)
      );

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              //window.location.hash = `#${entry.target.id}`;
              setSidebarItemsState(
                updateSidebarItems(sidebarItemsState, entry.target.id)
              );
            }
          });
        },
        { threshold: 0.1 }
      );

      sectionElements.forEach((el) => el && observer.observe(el));

      return () =>
        sectionElements.forEach((el) => el && observer.unobserve(el));
    }, 100);

    handleScroll();
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [sidebarItems]);

  // useEffect(() => {
  //   if (hash) {
  //     //scrollToSection(hash);
  //     setSidebarItemsState(updateSidebarItems(sidebarItemsState, hash));
  //   }
  // }, [hash]);

  return (
    <div className="flow-root my-24 sticky top-[180px]">
      {title && <>{title}</>}

      <ul role="list" className="-mb-8">
        {sidebarItemsState.map((item, itemIdx) => (
          <li key={item.id}>
            <div className="relative pb-8">
              {itemIdx !== sidebarItemsState.length - 1 ? (
                <span
                  className="absolute left-2 top-4 -ml-px h-full w-0.5 bg-gray-300"
                  aria-hidden="true"
                />
              ) : null}
              <span
                className="relative flex space-x-3 cursor-pointer"
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  scrollToSection(item.hash);
                }}
              >
                <div>
                  <span
                    className={classNames(
                      item.isActive
                        ? 'bg-primary ring-primary'
                        : 'bg-white ring-gray-300',
                      'flex h-4 w-4 items-center justify-center rounded-full ring-1 '
                    )}
                  ></span>
                </div>
                <div className="flex min-w-0 flex-1 justify-between space-x-4">
                  <p
                    className={classNames(
                      item.isActive ? 'font-semibold pr-6' : 'pr-6 font-normal',
                      'text-sm text-gray-500'
                    )}
                  >
                    {item.content}
                  </p>
                </div>
              </span>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Sidebar;
